import { Menu, Sun, Moon, ChevronDown } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";
import { useNavigate } from "react-router-dom";
import { useState, useRef, useEffect, useContext } from "react";
import Fqicon from "../../assets/img/Fq.png";
import LogoutIcon from "../../assets/icons/LogoutIcon.svg";
import ChangePasswordIcon from "../../assets/icons/ChangePasswordIcon.svg";
import AuthContext from "../../auth/AuthContext";

export default function Navbar({ toggleSidebar }) {
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const authContext = useContext(AuthContext);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getInitials = (name = "") => {
    if (!name) return "";
    const parts = name.trim().split(" ").filter(Boolean);
    return parts.length === 1
      ? parts[0][0].toUpperCase()
      : (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  return (
    <header
      className="
        bg-white dark:bg-slate-900
        border-b border-slate-200 dark:border-white/10
        px-3 md:px-4
        py-2 md:py-3
        flex items-center justify-between
        shadow-sm
      "
    >
      {/* LEFT */}
      <div className="flex items-center gap-3">
        {/* ☰ menu till xl */}
        <button
          onClick={toggleSidebar}
          className="xl:hidden text-slate-700 dark:text-slate-200"
        >
          <Menu size={30} />
        </button>

        <img
          src={Fqicon}
          alt="FQ Logo"
          className="h-10 sm:h-12 md:h-12 lg:h-14 w-auto object-contain"
        />
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-3 relative" ref={dropdownRef}>
        {/* Theme toggle */}
        <button
          onClick={toggleTheme}
          className="
            p-2.5 rounded-xl transition-all
            text-slate-700 dark:text-slate-200
            bg-white/70 dark:bg-slate-900/60
            border border-slate-200 dark:border-white/10
            hover:bg-slate-100 dark:hover:bg-white/10
          "
        >
          {theme === "light" ? (
            <Moon size={18} />
          ) : (
            <Sun size={18} className="text-yellow-400" />
          )}
        </button>

        {/* Avatar */}
        <button
          onClick={() => setOpen((p) => !p)}
          className="flex items-center gap-2 p-1 rounded-full hover:bg-slate-100 dark:hover:bg-white/10"
        >
          <div className="w-9 h-9 rounded-full flex items-center justify-center bg-[#0e3a46] text-white">
            {getInitials(authContext.displayName)}
          </div>

          <p className="max-w-[120px] truncate font-semibold text-slate-700 dark:text-slate-200">
            {authContext.displayName}
          </p>

          <ChevronDown size={16} />
        </button>

        {/* Dropdown */}
        {open && (
          <div className="absolute right-0 top-14 w-52 bg-white dark:bg-slate-800 rounded-md shadow py-4 z-50">
            <button
              onClick={() => {
                setOpen(false);
                navigate("/reset-password");
              }}
              className="w-full flex items-center gap-3 px-4 py-2 text-sm hover:bg-slate-100 dark:hover:bg-white/10 text-slate-800 dark:text-slate-100"
            >
              <img src={ChangePasswordIcon} alt="password" className="w-7 h-7" />
              Change Password
            </button>

            <button
              onClick={() => {
                setOpen(false);
                navigate("/logout", { replace: true });
              }}
              className="w-full flex items-center gap-3 px-4 py-2 text-sm text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10"
            >
              <img src={LogoutIcon} alt="logout" className="w-7 h-7" />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
